module.exports = __webpack_public_path__ + "static/media/down1.1cea29d7.jpg";